import h1 from './h1.svg'
import h2 from './h2.svg'
import h3 from './h3.svg'

export default { h1, h2, h3 }
